import { setNotificationModalHidden } from '@atredux/slices/notificationSlice'
import { store } from '@atredux/store'

export const notificationModalListener = async () => {
    store.dispatch(setNotificationModalHidden())
    return Promise.resolve({})
}
